import { Component, input, Input, InputSignal, ViewChild, computed } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import moment from 'moment';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, MatDatepickerInput, ReactiveFormsModule, MatDatepickerToggle, MatSuffix, MatDatepicker, TranslatePipe]
})
export class DatePickerComponent {
  label = input<string>('');

  placeholder = input<string>('');

  formControlRef = input.required<FormControl>();

  email = input<boolean>(false);

  required = input<boolean>(false);

  min = input<Date | undefined>();

  max = input<Date | undefined>();

  minMoment = computed(() => this.min() ? moment(this.min()) : null);
  maxMoment = computed(() => this.max() ? moment(this.max()) : null);

  weekFilter = input<boolean>(false);

  viewMode = input<'month' | 'year' | 'multi-year'>('month');

  appearance: MatFormFieldAppearance = 'outline';

  @ViewChild(MatDatepicker) datepicker!: MatDatepicker<any>;

  dateFilter: (date: moment.Moment | null) => boolean = (date: moment.Moment | null) => {
    if (!this.weekFilter()) {
      return true;
    }

    if (!date) {
      return false;
    }

    const day = date.toDate().getDay();
    return day !== 0 && day !== 6;
  };

  onMonthSelected(normalizedMonthAndYear: moment.Moment, datepicker: MatDatepicker<any>) {
    this.formControlRef().setValue(normalizedMonthAndYear.toDate());
    datepicker.close();
  }

  onDateInput(event: Event): void {
    if (this.viewMode() !== 'month') return;
    const input = event.target as HTMLInputElement;
    const val = input.value;
    const digits = val.replace(/\D/g, '').slice(0, 8);

    let d = digits.slice(0, 2);
    let m = digits.slice(2, 4);
    const y = digits.slice(4, 8);

    if (d.length === 2) {
      const dayNum = parseInt(d, 10);
      if (dayNum < 1) d = '01';
      else if (dayNum > 31) d = '31';
    }

    if (m.length === 2) {
      const monNum = parseInt(m, 10);
      if (monNum < 1) m = '01';
      else if (monNum > 12) m = '12';
    }

    const corrected = d + m + y;
    let formatted = corrected;
    if (corrected.length > 4) {
      formatted = corrected.slice(0, 2) + '/' + corrected.slice(2, 4) + '/' + corrected.slice(4);
    } else if (corrected.length > 2) {
      formatted = corrected.slice(0, 2) + '/' + corrected.slice(2);
    }

    if (formatted !== val) {
      input.value = formatted;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

